import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CardContent,
    Chip,
    Button,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Link,
} from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';
import { toast } from 'react-toastify';
import websiteSettingsService from '../../../services/websiteSettingsService';

// "Commande sur mesure" requests sent from the website contact section.
const CustomOrderRequests = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            setRequests(await websiteSettingsService.getCustomOrderRequests());
        } catch (err) {
            console.error(err);
            toast.error('Impossible de charger les demandes.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    const toggle = async (r) => {
        const next = r.status === 'HANDLED' ? 'NEW' : 'HANDLED';
        try {
            const updated = await websiteSettingsService.updateCustomOrderRequestStatus(r.id, next);
            setRequests((prev) => prev.map((x) => (x.id === r.id ? updated : x)));
        } catch (err) {
            toast.error(err.response?.data?.message || 'Erreur lors de la mise à jour.');
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                <InboxIcon color="primary" fontSize="large" />
                <Typography variant="h4">Commandes sur mesure</Typography>
            </Box>
            <Card>
                <CardContent>
                    {loading ? (
                        <Typography>Chargement…</Typography>
                    ) : requests.length === 0 ? (
                        <Typography color="text.secondary">Aucune demande pour le moment.</Typography>
                    ) : (
                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Client</TableCell>
                                        <TableCell>Contact</TableCell>
                                        <TableCell>Demande</TableCell>
                                        <TableCell>Statut</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {requests.map((r) => (
                                        <TableRow key={r.id} hover>
                                            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                                {r.createdAt ? new Date(r.createdAt).toLocaleString('fr-FR') : ''}
                                            </TableCell>
                                            <TableCell>{r.fullName}</TableCell>
                                            <TableCell>
                                                <Link href={`tel:${r.phone}`} underline="hover">{r.phone}</Link>
                                                {r.email && (<><br /><Link href={`mailto:${r.email}`} underline="hover">{r.email}</Link></>)}
                                            </TableCell>
                                            <TableCell sx={{ maxWidth: 420, whiteSpace: 'pre-wrap' }}>{r.message}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={r.status === 'HANDLED' ? 'Traitée' : 'Nouvelle'}
                                                    color={r.status === 'HANDLED' ? 'default' : 'warning'}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <Button size="small" onClick={() => toggle(r)}>
                                                    {r.status === 'HANDLED' ? 'Rouvrir' : 'Marquer traitée'}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default CustomOrderRequests;
